import React, { useState, useEffect } from "react";
import "../../styles/FolderWindow.css";
import { fetchFolderContents } from "../FirebaseUtils";
import AudioPlayer from "../Player/AudioPlayer";
import VideoPlayer from "../Player/VideoPlayer";
import TXTViewer from "./LegalWindow";
import backButton from "../../assets/images/back.png";
import closeButton from "../../assets/images/close.png";


const FolderWindow = ({ folderPath, embedContent, onClose }) => {
  const [contents, setContents] = useState({ folders: [], files: [] });
  const [audioSrc, setAudioSrc] = useState(null);
  const [audioPath, setAudioPath] = useState(null);
  const [videoSrc, setVideoSrc] = useState(null);
  const [currentPath, setCurrentPath] = useState(folderPath);
  const [isLoading, setIsLoading] = useState(false);
  const [txtFileUrl, setTxtFileUrl] = useState(null);

  useEffect(() => {
    if (!embedContent) {
      const fetchContents = async () => {
        setIsLoading(true);
        try {
          const data = await fetchFolderContents(currentPath);
          setContents(data);
        } catch (error) {
          console.error("Error fetching folder contents:", error);
        } finally {
          setIsLoading(false);
        }
      };
      fetchContents();
    }
  }, [currentPath, embedContent]);

  const handleOpenSubfolder = (subfolderPath) => {
    setCurrentPath(subfolderPath);
  };

  const handleBack = () => {
    const parentPath = currentPath.substring(0, currentPath.lastIndexOf("/"));
    setCurrentPath(parentPath || "");
  };

  const handleFileClick = (file) => {
    const extension = file.name.split(".").pop().toLowerCase();
    if (["mp3", "wav"].includes(extension)) {
      setAudioSrc(file.url);
      setAudioPath(file.path);
    } else if (["mp4", "webm"].includes(extension)) {
      setVideoSrc(file.url);
    } else if (extension === "txt") {
      setTxtFileUrl(file.url);
    }
    else {
      window.open(file.url, "_blank");
    }
  };

  return (
      <div className="folder-window">
        <div className="folder-header">
          <span>{embedContent ? "Streaming" : currentPath || "Other stuff"}</span>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer" }}>
            <img src={closeButton} alt="Close" style={{ width: "24px", height: "auto" }} />
          </button>
        </div>

        <div className="folder-content">
          {embedContent ? (
            <div dangerouslySetInnerHTML={{ __html: embedContent }} />
          ) : isLoading ? (
            <div className="loading-spinner">Loading...</div>
          ) : (
            <>
              {currentPath && currentPath !== "" && (
                <button onClick={handleBack} style={{ border: "none", background: "none" }}>
                  <img src={backButton} alt="Back" style={{ width: "24px", height: "auto" }} />
                </button>
              )}

              <div className="folder-section">
                <h3>Folders:</h3>
                <ul>
                  {contents.folders.map((folder, index) => (
                    <li
                      key={index}
                      onClick={() => handleOpenSubfolder(folder.path)}
                      style={{ cursor: "pointer" }}
                    >
                      <span role="img" aria-label="folder">
                        📁
                      </span>{" "}
                      {folder.name}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="file-section">
                <h3>Files:</h3>
                <ul>
                  {contents.files.map((file, index) => (
                    <li key={index} onClick={() => handleFileClick(file)}>
                      <span role="img" aria-label="file">
                        📄
                      </span>{" "}
                      {file.name}
                    </li>
                  ))}
                </ul>
              </div>
            </>
          )}
          {txtFileUrl && (
            <TXTViewer
              fileUrl={txtFileUrl}
              title="Text Document"
              onClose={() => setTxtFileUrl(null)}
            />
          )}
        </div>
        {audioSrc && (
          <AudioPlayer
            audioSrc={audioSrc}
            audioPath={audioPath}
            onClose={() => {
              setAudioSrc(null);
              setAudioPath(null);
            }}
          />
        )}
        {videoSrc && (
          <VideoPlayer
            videoSrc={videoSrc}
            onClose={() => setVideoSrc(null)}
          />
        )}
      </div>
  );
};

export default FolderWindow;